module.exports = __webpack_public_path__ + "img/brand-personality-titel.40b49a32.png";